import React from 'react'
import { compose } from 'redux'
import { Field, propTypes as formPropTypes } from 'redux-form'
import { ButtonArea, SubmitButton, Input } from 'lp-components'
import { lpForm } from 'lp-form'

const propTypes = {
  ...formPropTypes,
}

const defaultProps = {}

function ResetPasswordForm({ handleSubmit, submitting, error }) {
  return (
    <form onSubmit={handleSubmit} noValidate>
      {error && (
        <p className="full-error-message" role="alert">
          There was a problem resetting your password, please check your email
          for new password reset instructions and try again.
        </p>
      )}
      <Field
        name="password"
        component={Input}
        type="password"
        autoComplete="new-password"
      />
      <Field
        name="passwordConfirmation"
        label="Confirm Password"
        component={Input}
        type="password"
        autoComplete="new-password"
      />
      <ButtonArea>
        <SubmitButton submitting={submitting}>Submit</SubmitButton>
      </ButtonArea>
    </form>
  )
}

ResetPasswordForm.propTypes = propTypes
ResetPasswordForm.defaultProps = defaultProps

export default compose(
  lpForm({
    name: 'school-portal-reset-password',
    constraints: {
      password: {
        presence: { message: '^Enter a new password.' },
        length: {
          minimum: 6,
          tooShort: '^Enter at least %{count} characters.',
        },
      },
      passwordConfirmation: {
        presence: { message: '^Confirm your new password.' },
        equality: {
          attribute: 'password',
          message: '^Passwords must match.',
        },
      },
    },
  })
)(ResetPasswordForm)
